import React, { useLayoutEffect, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import MobileBody from 'components/MobileBody';
import FormSreenStatics from 'components/FormSreenStatics';
import { ScreenStaticsType } from 'types/SreenStaticsType';
import { getScreensStatics } from './reqs';
import ScreensStaticContext from 'context/ScreensStaticContext';
import ReturnBodyStaticScreen from 'components/ReturnBodyStaticScreen';
import Load from 'components/Load';

export default function ScreensStatic() {
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { i18n }: UseTranslationProps = useTranslation();
	const { setScreens } = useContext(ScreensStaticContext);

	const [isOpenForm, setIsOpenForm] = useState(false);
	const [isLoad, setIsLoad] = useState(false);
	const [typeForm, setTypeForm] = useState<ScreenStaticsType>('');

	function openForm(typeForm: ScreenStaticsType) {
		setTypeForm(typeForm);
		setIsOpenForm(true);
	}

	useEffect(() => {
		(async () => {
			setIsLoad(true);
			setScreens(await getScreensStatics(handleNotify));
			setIsLoad(false);
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'Telas estáticas' }));
	}, [i18n?.language]);

	return (
		<S.container>
			{isLoad ? (
				<S.centalizeLoad>
					<Load showText text="Buscando telas estáticas" />
				</S.centalizeLoad>
			) : (
				<S.screens>
					<S.screen onClick={() => openForm('campaign')}>
						<MobileBody
							textTitle="Campanha"
							showFaceId={false}
							showHeaderPhone={false}
						>
							<ReturnBodyStaticScreen type="campaign" />
						</MobileBody>
					</S.screen>

					<S.screen onClick={() => openForm('inovation')}>
						<MobileBody
							showFaceId={false}
							textTitle="Inovação"
							showHeaderPhone={false}
						>
							<ReturnBodyStaticScreen type="inovation" />
						</MobileBody>
					</S.screen>

					<S.screen onClick={() => openForm('blackFriday')}>
						<MobileBody
							showHeaderPhone={false}
							textTitle="Black friday"
							backgroundColor="#522573"
							useBackground={false}
						>
							<ReturnBodyStaticScreen type="blackFriday" />
						</MobileBody>
					</S.screen>
				</S.screens>
			)}

			{isOpenForm && (
				<FormSreenStatics
					typeForm={typeForm}
					isOpen={isOpenForm}
					setIsOpen={setIsOpenForm}
					setTypeForm={setTypeForm}
				/>
			)}
		</S.container>
	);
}
